import React from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import OurTeam from "../Components/OurTeam";
import SoloPage from "../Components/SoloPage";

function OurTeamRouter() {
    return (
        <Router>
            <Link>
                <Route exact path="/" component={OurTeam} />
                <Route path="/team/:id" component={SoloPage} />
            </Link>
        </Router>
    );
}

export default OurTeamRouter;
